export default __webpack_public_path__ + "static/bg-e0a5c771452b60c80d6dbf27b2a98862.png";